<div class="row align-top gutters">

  <div class="col-md-4">
    <div [ngClass]="permissions.loansPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'" class="gray">
      @if (permissions.loansPermissions._edit) {
        <span></span>
      }
      Closing Feasibility Notes
      @if (permissions.loansPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleNotesEditMode()">
            @if (!notesEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (notesEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>

    @if (!permissions.loansPermissions._edit || !notesEditMode) {
      <div>
        @if (closingNotes) {
          <div class="notes-read-only">{{closingNotes}}</div>
        }
        @if (!closingNotes) {
          <i>There are no Closing Feasibility Notes for this deal.</i>
        }
      </div>
    }

    @if (permissions.loansPermissions._edit && notesEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Closing Feasibility Notes here</mat-label>
          <textarea matInput
            [formControl]="notes"
          (change)="notesChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>

  <div class="col-md-4">
    <div [ngClass]="permissions.loansPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'" class="gray">
      @if (permissions.loansPermissions._edit) {
        <span></span>
      }
      Loan Details
      @if (permissions.loansPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleRateEditMode()">
            @if (!isRateEdit) {
              <mat-icon>edit</mat-icon>
            }
            @if (isRateEdit) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    <div class="set-asides-question">
      <b>Rate Lock? </b>
      @if (!permissions.loansPermissions._edit || !isRateEdit) {
        <span>{{ratelockString}}</span>
      }
      @if (permissions.loansPermissions._edit && isRateEdit) {
        <mat-radio-group [(ngModel)]="isRateLocked" aria-label="Select yes or no for Rate Lock">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      }
    </div>
  </div>
</div>

<div class="row align-top gutters">
  <div class="col-md-12">
    <div [ngClass]="permissions.loansPermissions._edit && loansFromModels.length <= 0 ? 'subsection-header-with-button' : 'subsection-header'"
      class="purple-dark">
      @if (permissions.loansPermissions._edit && loansFromModels.length <= 0) {
        <span></span>
      }
      Loans
      @if (permissions.loansPermissions._edit && loansFromModels.length <= 0) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleLoansEditMode()" [disabled]="loading || checkLoans()">
            @if (!loansEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (loansEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
          @if (permissions.loansPermissions._edit && loansFromModels.length <= 0 && loansEditMode) {
            <button mat-mini-fab (click)="addLoan()" class="add-button"
              [disabled]="checkLoans()">
              @if (loansEditMode) {
                <mat-icon>add</mat-icon>
              }
            </button>
          }
        </span>
      }
    </div>

    @if (loans.length <= 0) {
      <div class="col-md-12">
        <em>There are no Loans for this deal.</em>
      </div>
    }

    @if (loans.length > 0) {
      <div class="mat-elevation-z8">
        <table mat-table class="stripped-table" #loansable
          #dataSort="matSort" [dataSource]="loanDataSource" matSort>
          <!-- Lender Column -->
          <ng-container matColumnDef="lender">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Lender </th>
            <td mat-cell *matCellDef="let row; let i = index;">
              @if (!loansEditMode) {
                <span>{{row.lender}}</span>
              }
              @if (loansEditMode) {
                <mat-form-field>
                  <mat-label [style.color]="row.newlender === '' ? '#d34141' : ''">Enter Lender</mat-label>
                  <input matInput type="text" [(ngModel)]="row.newlender" required (ngModelChange)="this.lenderUpdate.next($event)"
                    [disabled]="loading">
                </mat-form-field>
              }
            </td>
          </ng-container>
          <!-- Loan Type Column -->
          <ng-container matColumnDef="loantype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Loan Type </th>
            <td mat-cell *matCellDef="let row">
              @if (!loansEditMode) {
                <span>{{row.loantype}}</span>
              }
              @if (loansEditMode) {
                <mat-form-field appearance="fill">
                  <mat-label [style.color]="!row.newloantypeid || row.newloantypeid === '' ? '#d34141' : ''">Choose a Loan Type</mat-label>
                  <mat-select [(value)]="row.newloantypeid" required>
                    @for (type of loanTypes; track type) {
                      <mat-option [value]="type.id">{{type.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </td>
          </ng-container>
          <!-- Amount Column -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount </th>
            <td mat-cell *matCellDef="let row">
              @if (!loansEditMode) {
                <span>{{row.amountFormatted}}</span>
              }
              @if (loansEditMode) {
                <mat-form-field>
                  <mat-label [style.color]="row.newamount === '' ? '#d34141' : ''">Enter Amount</mat-label>
                  <input matInput type="number" [(ngModel)]="row.newamount" required>
                </mat-form-field>
              }
            </td>
          </ng-container>
          <!-- Available Column -->
          <ng-container matColumnDef="available">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Available to Investor </th>
            <td mat-cell *matCellDef="let row; let i = index;">
              @if (!loansEditMode) {
                <span>{{row.available}}</span>
              }
              @if (loansEditMode) {
                <span class="value-column">
                  <mat-form-field appearance="fill">
                    <mat-label>Select Yes or No</mat-label>
                    <mat-select [(value)]="row.newavailable">
                      <mat-option [value]="true">Yes</mat-option>
                      <mat-option [value]="false">No</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="warn" aria-label="Delete Loan" (click)="deleteLoan(row, i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </span>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="loanColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: loanColumns;"></tr>
        </table>
      </div>
    }
  </div>
</div>
